<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Edition de l'utilisateur</span>
    </sticky>
    <div class="columns is-gapless has-bg-light is-padding">
      <div class="column is-8 is-8-widescreen is-padding-right">
        <div class="has-bg-white is-radius-large is-border">
          <form @submit.prevent.stop="submit()" id="form-user">
            <div class="columns is-multiline is-margin-top-small">
              <div class="column is-9 is-padding-bottom-xsmall">
                <div class="columns is-gapless">
                  <div class="column">
                    <h2 class="title is-2 has-text-weight-black">Informations Utilisateur</h2>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-5 is-paddingless-left">
                    <v-input id="password1" name="password" :inputType="displayClearPassword ? 'text' : 'password'" @input="val => password = val"
                              :model="password"
                              label="Mot de passe actuel *"
                              v-validate="'required|min:6'" :errors-bag="errors" data-vv-value-path="val"
                              data-vv-as="Mot de passe">
                    </v-input>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-5 is-paddingless-left">
                    <v-input id="newPassword1" name="newPassword" :inputType="displayClearPassword ? 'text' : 'password'" @input="val => newPassword = val"
                              :model="newPassword"
                              label="Nouveau mot de passe *"
                              v-validate="'required|min:6'" :errors-bag="errors" data-vv-value-path="val"
                              data-vv-as="Mot de passe">
                    </v-input>
                  </div>
                  <div class="column is-5 is-paddingless-right">
                    <v-input id="password2" name="confirmPassword" :inputType="displayClearPassword ? 'text' : 'password'"
                              @input="val => confirmPassword = val"
                              :model="confirmPassword"
                              label="Confirmation du nouveau mot de passe *"
                              v-validate="'required|min:6'" :errors-bag="errors" data-vv-value-path="val"
                              data-vv-as="Confirmation du mot de passe">
                    </v-input>
                  </div>
                </div>
                <a class="column is-narrow is-paddingless" @click="displayClearPassword = !displayClearPassword">
                  <i class="is-margin-right-xsmall fal fa-eye" :class="displayClearPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                  <span>{{!displayClearPassword ? 'Afficher' : 'Cacher'}} les mots de passe</span>
                </a>
              </div>
            </div>
            <div class="column is-12 is-margin-top is-paddingless-left is-paddingless-rigt is-border-top columns">
              <div class="column is-6">
                <a @click="$router.goBack(route)" class="button has-bg-white is-uppercase is-fullwidth">
                    <span>Annuler</span>
                  </a>
              </div>
              <div class="column is-6">
                <button class="button is-success is-uppercase is-fullwidth has-text-white" type="submit" :disabled="!canSubmit || loading">Valider</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'ChangePassword',
    data () {
      return {
        loading: false,
        password: null,
        confirmPassword: null,
        newPassword: null,
        displayClearPassword: false,
        route: this.$route
      }
    },
    computed: {
      ...mapGetters(['currentUserPk']),
      samePassword () {
        return this.newPassword && this.newPassword === this.confirmPassword
      },
      canSubmit () {
        return this.samePassword && this.password
      }
    },
    methods: {
      submit () {
        if (!this.samePassword) {
          this.$notify({
            type: 'is-danger',
            text: 'Les deux mots de passe ne sont pas identiques.'
          })
          return
        }
        let data = {
          password: this.password,
          new_password: this.newPassword
        }
        this.loading = true
        this.$api.userService.updatePassword(data, this.$configs.APPHOST).then((r) => {
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'Mot de passe mis à jour avec succès.'
          })
          this.$router.replace({name: 'UserVue', params: {id: 'me'}, force: true})
        }).catch(() => {
          this.loading = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la mise à jour de votre mot de passe. Veuillez vérifiez le formulaire.'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/ChangePassword.vue